import { render, staticRenderFns } from "./UploadAttachFile.vue?vue&type=template&id=1f8a1ae4&"
import script from "./UploadAttachFile.vue?vue&type=script&lang=js&"
export * from "./UploadAttachFile.vue?vue&type=script&lang=js&"
import style0 from "./UploadAttachFile.vue?vue&type=style&index=0&id=1f8a1ae4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports